import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';
export var ComposeScenario;
(function (ComposeScenario) {
    ComposeScenario[ComposeScenario["Send"] = 0] = "Send";
    ComposeScenario[ComposeScenario["Save"] = 1] = "Save";
    ComposeScenario[ComposeScenario["Discard"] = 2] = "Discard";
})(ComposeScenario || (ComposeScenario = {}));
export function logSmartReplyDatapoint(scenario, smartReplyExtractionId) {
    if (!smartReplyExtractionId) {
        // Nothing to log -- compose instance not created via smart reply.
        return;
    }
    var smartReplyDatapoint = null;
    switch (scenario) {
        case 0 /* Send */:
            smartReplyDatapoint = datapoints.SmartReplySendMessage;
            break;
        case 1 /* Save */:
            smartReplyDatapoint = datapoints.SmartReplySaveMessage;
            break;
        case 2 /* Discard */:
            smartReplyDatapoint = datapoints.SmartReplyDiscardMessage;
            break;
    }
    var _a = smartReplyDatapoint.datapoint, eventName = _a.name, customData = _a.customData;
    logUsage(eventName, customData(smartReplyExtractionId));
}
//# sourceMappingURL=logSmartReplyComposeDatapoint.js.map